<template>
  <ax-dialog 
    ref="dialog"
    title="Multi-dimensional statistics" 
    icon="mdi-table-large" 
    tooltip="Multi-dimensional statistics"
    size="small" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <v-autocomplete multiple :items="nominals" v-model="dimensions" :rules="rules.required.concat(rules.minTwo)" label="Dimensions" />
        <v-autocomplete multiple :items="measures.options" v-model="measures.selected" :rules="rules.required" label="Measurements" />
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgSummaryStats",
  props: {
    nominals: { type: Array, required: true }
  },
  components: { 
    AxDialog
  },
  data() {
    return {
      dimensions: [],
      measures: {
        selected: [],
        options: [
          { text: 'Average', value: 'mean' },
          { text: 'P1', value: 'p1' },
          { text: 'P10', value: 'p10' },
          { text: 'P50', value: 'p50' },
          { text: 'P90', value: 'p90' },
          { text: 'P99', value: 'p99' },
          { text: 'P90/P10', value: 'ratio' },
        ]
      },
      rules: {
        required: [
          v => !!v || 'Required',
          v => !this.isEmpty(v)
        ],
        minTwo: [
          v => (v && v.length >= 2) || 'Minimun 2 values required.'
        ]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$nextTick(() => {
        //manually trigger Vuetify validation
        if (this.$refs.dialog.$refs.form.validate()) {
          this.$refs.dialog.show = false
          this.$emit('submitted', this.dimensions)
        }
      })
    }
  }
}
</script>